import React, { useState } from 'react';
import ElectiveClassifications from '../Widgets/Overview/ElectiveClassifications';
import InstitutionalClassification from '../Widgets/Overview/InstitutionalClassification';
import ResearchActivityDesignation from '../Widgets/Overview/ResearchActivityDesignation';
import StudentAccessAndEarnings from '../Widgets/Overview/StudentAccessAndEarnings';
import PanelTitle from './PanelTitle';
import Panel from './Panel';
import { Col, Row } from 'react-bootstrap';

export default function Overview({ institutionData, updateTab }) {

    const sae = institutionData.post_meta.saec2025.value > 0;
    const rad = institutionData.post_meta.research2025.value > 0;

    return (
        <Panel className="overview">
            <Row>
                <Col xs={12}>
                    <PanelTitle>Overview</PanelTitle>
                </Col>
            </Row>
            <Row lg={2} xs={1}>
                <Col xs={12} lg={6} className="mb-4">
                    <InstitutionalClassification institutionData={institutionData} updateTab={updateTab} />
                </Col>
                {sae &&
                    <Col xs={12} lg={6} className="mb-4">
                        <StudentAccessAndEarnings institutionData={institutionData} updateTab={updateTab} />
                    </Col>
                }
                {rad &&
                    <Col xs={12} lg={6} className="mb-4">
                        <ResearchActivityDesignation institutionData={institutionData} updateTab={updateTab} />
                    </Col>
                }
                <Col xs={12} lg={6} className="mb-4">
                    <ElectiveClassifications institutionData={institutionData} />
                </Col>
            </Row>
        </Panel>
    );
}